// extracted by mini-css-extract-plugin
module.exports = {"description":"styles__description___3X6yP","title":"styles__title___1gFXO","about":"styles__about___3d8la","error":"styles__error___2wLs7"};